import PageHero from '@/components/feature/PageHero';
import { investHero } from '@/mocks/invest';

export default function Hero() {
  return (
    <PageHero
      eyebrow={investHero.eyebrow}
      title={investHero.title}
      titleHighlight={investHero.titleHighlight}
      subtitle={investHero.subtitle}
      desc={investHero.desc}
      imageUrl="https://readdy.ai/api/search-image?query=Vast%20rural%20digital%20economy%20landscape%20with%20glowing%20data%20network%20lines%20connecting%20county%20towns%20and%20villages%2C%20futuristic%20smart%20agriculture%20and%20digital%20commerce%20hubs%2C%20deep%20navy%20ink%20and%20eco%20green%20gold%20accent%20lighting%2C%20national%20strategy%20technology%20aesthetic%2C%20cinematic%20aerial%20soft%20lighting&width=1800&height=1200&seq=invest-hero-01&orientation=landscape"
      imageAlt="九畴云铺乡村数字经济投资与合作"
      imageTitle="九畴云铺 投资与合作"
    />
  );
}